import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  container: (props) => ({
    minHeight: props.minHeight,
  }),
}))
